import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ManagementContainerModel, ManagementShipmentModel } from '@data-layer/models/management';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { enumIncotermsType } from '@data-layer/enums/lcl/enumIncotermsType';
import { enumShipmentState } from '@data-layer/enums/lcl';
import { precisionRound } from '@helpers/data-transform.helper';

@Component({
  selector: 'voyage-shipments-table',
  templateUrl: './voyage-shipments-table.component.html',
  styleUrls: ['./voyage-shipments-table.component.scss'],
})
export class VoyageShipmentsTableComponent implements OnChanges {
  @Input() public isShowCheckbox: boolean;
  @Input() public isShowContainerHeader: boolean;
  @Input() public isShowDelete: boolean;
  @Input() public isColoading: boolean;
  @Input() public totalCostContainer: number;
  @Input() public shipments: ManagementShipmentModel[];
  @Input() public container: ManagementContainerModel;
  @Output() public checkboxChecked: EventEmitter<{ shipmentId: number; isChecked: boolean }> = new EventEmitter<{
    shipmentId: number;
    isChecked: boolean;
  }>();
  @Output() public delete: EventEmitter<void> = new EventEmitter<void>();
  @Output() public moveShipmentSource: EventEmitter<{ shipmentId: number; referenceNumber: string }> = new EventEmitter<{
    shipmentId: number;
    referenceNumber: string;
  }>();

  public totalVolume: number;
  public totalWeight: number;
  public totalPackages: number;
  public totalCost: number;

  public enumIncotermsType: typeof enumIncotermsType = enumIncotermsType;
  public enumShipmentState: typeof enumShipmentState = enumShipmentState;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.shipments) {
      this.calcTotals();
    }
  }

  public totalValue(field: string, subField?: string): number {
    return precisionRound(
      (this.shipments || []).reduce((acc: number, currentShipment: ManagementShipmentModel) => {
        return this.isShipmentArrived(currentShipment.trackingState) && !this.isShipmentCanceled(currentShipment.state)
          ? acc + (!!subField ? currentShipment.aggregatedStatistics?.[subField]?.[field] : currentShipment.aggregatedStatistics?.[field])
          : acc;
      }, 0),
    );
  }

  public isShipmentArrived(state: enumLclTrackingStates): boolean {
    return state >= enumLclTrackingStates.AT_ORIGIN_WAREHOUSE;
  }

  public isShipmentMoveable(state: enumLclTrackingStates): boolean {
    return state <= enumLclTrackingStates.AT_ORIGIN_WAREHOUSE;
  }

  public isShipmentCanceled(state: enumShipmentState): boolean {
    return state === enumShipmentState.CANCELED;
  }

  public onCheckboxChecked(shipmentId: number, event: any): void {
    this.checkboxChecked.emit({ shipmentId, isChecked: event.target.checked });
  }

  public moveShipment(shipmentId: number, referenceNumber: string): void {
    this.moveShipmentSource.emit({ shipmentId: shipmentId, referenceNumber: referenceNumber });
  }

  private calcTotals(): void {
    this.totalVolume = this.totalValue('totalVolume', 'realMeasurements');
    this.totalWeight = this.totalValue('totalWeight', 'realMeasurements');
    this.totalPackages = this.totalValue('totalPackages');
    this.totalCost = this.isColoading ? this.totalValue('totalCost') : this.totalValue('containerCost');
  }
}
